import {
  ResetPasswordForm,
  ResetPasswordFormData,
} from '@src/features/user/auth';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { resetPassword } from '@src/services/auth.ts';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export const ResetPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleResetPassword = useCallback(
    async (data: ResetPasswordFormData) => {
      try {
        await resetPassword({
          newPassword: data.password,
        });
        navigate('/signin');
      } catch {
        toast.error(t('toast.failedToResetPassword'));
      }
    },
    [navigate, t]
  );

  return <ResetPasswordForm onSubmit={handleResetPassword} />;
};
